import { Component, Input } from '@angular/core';


@Component({
  selector: 'ssf-details-button',
  template: require('./details-button.component.html'),
  styles: [require('./details-button.component.scss')]
})
export class DetailsButtonComponent {
  @Input() shown: boolean;
  public i18n = 'SHARED.DETAILS-BUTTON.';
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/details-button/details-button.component.ts